
import axios from 'axios';
import { reactive } from 'vue';
import api from '../../api';

const getDefaultState = () => reactive({
    availableGamePlays: 0,
    isGamePlayLimited: true,
    isPhotoUploadLimited: true,
});

const state = getDefaultState();

const getters = {};

const mutations = {
    updateState (state, {
        availableGamePlays = 0,
        isGamePlayLimited = true,
        isPhotoUploadLimited = true,
    } = {}) {

        state.availableGamePlays = availableGamePlays;
        state.isGamePlayLimited = isGamePlayLimited;
        state.isPhotoUploadLimited = isPhotoUploadLimited;
    },

    resetState (state) {
        for (const key in state) {
            delete state[key];
        }

        const defaultState = getDefaultState();
        for (const key in defaultState) {
            state[key] = defaultState[key];
        }
    },
};

const actions = {
    async getActivityStatus ({ dispatch }) {
        return dispatch('makeCall', {
            type: 'get',
            endpoint: 'activities/:status',
        });
    },

    async makeCall ({ commit }, {
        type = 'post',
        endpoint,
        data,
    }) {
        commit('resetState');

        try {
            const response = await axios[type](`${api.base}/${endpoint}`, data);

            commit('updateState', response.data);
        }
        catch (err) {
            console.error(
                `error making ${endpoint} call`,
                err.message,
                err,
            );

            throw err;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
